import React from "react";

/** Thin progress bar for partial / filled order amounts. */
const OrderFillBar = ({ order, className = "" }) => {
  const amount = Math.floor(Number(order?.amount) || 0);
  const filled = Math.floor(Number(order?.filledAmount) || 0);
  const pct = amount > 0 ? Math.min(100, Math.round((filled / amount) * 100)) : 0;

  return (
    <div
      className={`bcoin-ob-fill-bar${className ? ` ${className}` : ""}`}
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={`${pct}% matched`}
    >
      <span className={`bcoin-ob-fill-bar-track ${order?.side || ""}`}>
        <span className="bcoin-ob-fill-bar-value" style={{ width: `${pct}%` }} />
      </span>
    </div>
  );
};

export default OrderFillBar;
